import { render } from "./buildingTypeSelectorComponent.vue?vue&type=template&id=5e2f6e8c"
import script from "./buildingTypeSelectorComponent.vue?vue&type=script&lang=js"
export * from "./buildingTypeSelectorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__